// All of the requested modules are loaded behind enumerable getters.
const map = Object.defineProperties({}, {
  "./(auth)/_layout.tsx": { enumerable: true, get() { return import("/Users/antoine/Desktop/Fluentive/fluentive-console/src/screens/(auth)/_layout.tsx"); } },
  "./(auth)/sign-in.tsx": { enumerable: true, get() { return import("/Users/antoine/Desktop/Fluentive/fluentive-console/src/screens/(auth)/sign-in.tsx"); } },
  "./(auth)/sign-up.tsx": { enumerable: true, get() { return import("/Users/antoine/Desktop/Fluentive/fluentive-console/src/screens/(auth)/sign-up.tsx"); } },
  "./(dashboard)/_layout.tsx": { enumerable: true, get() { return import("/Users/antoine/Desktop/Fluentive/fluentive-console/src/screens/(dashboard)/_layout.tsx"); } },
  "./(dashboard)/accounts.tsx": { enumerable: true, get() { return import("/Users/antoine/Desktop/Fluentive/fluentive-console/src/screens/(dashboard)/accounts.tsx"); } },
  "./(dashboard)/index.tsx": { enumerable: true, get() { return import("/Users/antoine/Desktop/Fluentive/fluentive-console/src/screens/(dashboard)/index.tsx"); } },
  "./+not-found.tsx": { enumerable: true, get() { return import("/Users/antoine/Desktop/Fluentive/fluentive-console/src/screens/+not-found.tsx"); } },
  "./_layout.tsx": { enumerable: true, get() { return import("/Users/antoine/Desktop/Fluentive/fluentive-console/src/screens/_layout.tsx"); } },
});

function metroContext(request) {
    return map[request];
}

// Return the keys that can be resolved.
metroContext.keys = function metroContextKeys() {
  return Object.keys(map);
};

// Return the module identifier for a user request.
metroContext.resolve = function metroContextResolve(request) {
  throw new Error('Unimplemented Metro module context functionality');
}

module.exports = metroContext;